import React from 'react'

import { Link, useNavigate } from 'react-router-dom';
import BottomNavBar from '../components/BottomNavBar.jsx';
// c:\xampp\htdocs\miners-market-main\pages\KpInsurancePage.js

export default function KpInsurancePage({ user, basketCount, onToggleMenu, onShowChat, onSwitchRole, onShowLogin }) {
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [formData, setFormData] = React.useState({
        principal_contractor: false,
        sub_contractor: false,
        natural_person: false,
        legal_entity: false,
        company_name: '',
        trading_as: '',
        contact_name: user?.name || '',
        contact_numbers: user?.phone_number || '',
        email: user?.email || '',
        company_reg_no: '',
        owned_plant: false,
        hired_in_plant: false,
        owned_plant_hired_out: false,
        equipment_description: '',
        mm_number: '',
        equipment_year: '',
        brief_note: '',
        contact_method_call: false,
        contact_method_whatsapp: false,
        contact_method_email: false,
        consent: false,
    });
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [formError, setFormError] = React.useState(null);
    const [formSuccess, setFormSuccess] = React.useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError(null);
        setFormSuccess(null);

        // Basic validation
        if (!formData.company_name || !formData.contact_name || !formData.contact_numbers || !formData.email || !formData.consent) {
            setFormError('Please fill in all mandatory fields and provide consent.');
            setIsSubmitting(false);
            return;
        }
        if (!formData.contact_method_call && !formData.contact_method_whatsapp && !formData.contact_method_email) {
            setFormError('Please select at least one preferred contact method.');
            setIsSubmitting(false);
            return;
        }

        try {
            const response = await fetch('/api/submit_kp_insurance.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to submit form.');
            }
            setFormSuccess(result.message);
            // Optionally reset form or redirect
            setFormData({
                principal_contractor: false, sub_contractor: false, natural_person: false, legal_entity: false,
                company_name: '', trading_as: '', contact_name: '', contact_numbers: '',
                email: '', company_reg_no: '', owned_plant: false, hired_in_plant: false,
                owned_plant_hired_out: false, equipment_description: '', mm_number: '', equipment_year: '',
                brief_note: '', contact_method_call: false, contact_method_whatsapp: false, contact_method_email: false,
                consent: false,
            });
        } catch (err) {
            setFormError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div data-name="kp-insurance-page" data-file="pages/KpInsurancePage.js" className="min-h-screen bg-gray-100">
            {/* Sticky Navigation Header */}
            <div className="sticky top-0 z-50 bg-white shadow-md border-b border-gray-200">
                <div className="container mx-auto px-4 py-3">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                            <button
                                onClick={() => navigate('/')}
                                className="flex items-center text-gray-700 hover:text-blue-600 transition-colors"
                            >
                                <i className="fas fa-arrow-left mr-2"></i>
                                <span className="font-medium hidden sm:inline">Back to Home</span>
                            </button>
                        </div>
                        <div className="flex items-center space-x-2">
                            <img src="images/logo/MM Logo.jpg" alt="Miners Market Logo" className="h-8 w-auto rounded" />
                            <span className="text-sm font-bold text-gray-800 hidden sm:inline">King Price Insurance</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <button
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                                className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                            >
                                <i className="fas fa-bars text-gray-700 text-xl"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Menu Dropdown */}
            {isMobileMenuOpen && (
                <div className="fixed inset-0 z-[60]">
                    <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)}></div>
                    <div className="absolute right-0 top-0 h-full w-64 bg-white shadow-xl transform transition-transform">
                        <div className="p-4">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-lg font-bold text-gray-900">Menu</h3>
                                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 hover:bg-gray-100 rounded-lg">
                                    <i className="fas fa-times text-gray-700"></i>
                                </button>
                            </div>
                            <nav className="space-y-2">
                                <Link to="/equipment" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-truck mr-3"></i>Equipment
                                </Link>
                                <Link to="/consumables" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-box-open mr-3"></i>Consumables
                                </Link>
                                <Link to="/miscellaneous" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-th-large mr-3"></i>Miscellaneous
                                </Link>
                                <Link to="/rebuilds" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-wrench mr-3"></i>Rebuilds
                                </Link>
                                <Link to="/rentals" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-retweet mr-3"></i>Rentals
                                </Link>
                                <Link to="/commercial" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-building mr-3"></i>Commercial
                                </Link>
                                <Link to="/components-and-spares" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-cogs mr-3"></i>Components
                                </Link>
                                <div className="border-t border-gray-200 my-4"></div>
                                <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="block py-3 px-4 rounded-lg hover:bg-gray-100 text-gray-700 font-medium">
                                    <i className="fas fa-home mr-3"></i>Home
                                </Link>
                            </nav>
                        </div>
                    </div>
                </div>
            )}

            <div className="container mx-auto px-4 max-w-6xl py-8">
                <h1 className="text-5xl font-bold text-red-600 text-center mb-12">King Price Insurance</h1>

                {/* Introduction Section */}
                <div className="grid md:grid-cols-2 gap-8 mb-12">
                    {/* Left Side (Miners Market Focus) */}
                    <div className="bg-blue-800 text-white p-8 rounded-xl shadow-lg flex flex-col justify-between">
                        <div>
                            <div className="flex items-center mb-6">
                                <img src="images/logo/MM Logo.jpg" alt="Miners Market Logo" className="w-16 h-16 rounded-lg mr-4" />
                                <h2 className="text-3xl font-bold">A New Standard in Mining Machinery Insurance</h2>
                            </div>
                            <p className="text-lg mb-4">
                                Miners Market is excited to offer insurance support through King Price, providing a groundbreaking insurance solution for your heavy machinery.
                            </p>
                            <p className="mb-4">
                                As part of our mission to provide you with end-to-end solutions, we recognised the critical need for reliable, specialised insurance for your core assets. Your machinery is the backbone of your operation, and it deserves robust protection from unforeseen breakdowns, damage, and theft.
                            </p>
                            <p className="mb-6">
                                This seamless integration means Miners Market is now your true one-stop shop: source the equipment you need and insure it with trusted support, all in one place. We've handled the support integration so you can focus on your operation with complete peace of mind.
                            </p>
                            <p className="font-semibold text-xl">Secure your assets and streamline your processes today.</p>
                        </div>
                    </div>

                    {/* Right Side (King Price Focus) */}
                    <div className="bg-red-700 text-white p-8 rounded-xl shadow-lg flex flex-col justify-between">
                        <div>
                            <div className="flex items-center mb-6">
                                <img src="kp-logos/Rectangle.png" alt="King Price Logo" className="h-16 w-auto mr-4" />
                                <h2 className="text-3xl font-bold">Why King Price?</h2>
                            </div>
                            <p className="text-lg mb-4">
                                King Price is not just another insurer; we're a revolution in the South African insurance landscape. Our core belief is simple: insurance should be straightforward, fairly priced, and designed to save you money.
                            </p>
                            <p className="mb-4">
                                We've taken this proven model and engineered it specifically for the demands of the mining sector. We understand that downtime is your biggest enemy. That's why our machinery cover is built to get you back up and running faster, minimizing disruption and protecting your bottom line.
                            </p>
                            <p className="font-semibold text-xl mb-4">What this means for you:</p>
                            <ul className="list-disc list-inside space-y-2 mb-6">
                                <li><span className="font-bold">Fair, Dynamic Premiums:</span> Competitive pricing that reflects real value.</li>
                                <li><span className="font-bold">Simplified Claims:</span> A straightforward process to reduce downtime when you need us most.</li>
                                <li><span className="font-bold">Specialised Cover:</span> Insurance designed by experts who understand mining machinery.</li>
                                <li><span className="font-bold">Legendary Service:</span> The easy-to-deal-with approach we're famous for.</li>
                            </ul>
                            <p>This support from Miners Market allows us to bring our unique value directly to the industry's leading equipment platform.</p>
                        </div>
                    </div>
                </div>

                {/* Form Section */}
                <div id="kp-insurance-form" className="bg-white rounded-xl shadow-lg p-8">
                    <div className="flex justify-between items-center mb-8">
                        <img src="images/logo/MM Logo.jpg" alt="Miners Market Logo" className="w-12 h-12 rounded-lg" />
                        <h2 className="text-2xl font-bold text-gray-900 text-center">KING PRICE INSURANCE – PLANT ALL RISKS PROPOSAL CHECKLIST</h2>
                        <img src="kp-logos/Rectangle.png" alt="King Price Logo" className="h-12 w-auto" />
                    </div>

                    {formError && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm mb-4">{formError}</div>}
                    {formSuccess && <div className="bg-green-100 text-green-700 p-3 rounded-lg text-sm mb-4">{formSuccess}</div>}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Section 1: Policyholder Protection Rules & Insured Interests */}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">1. Policyholder Protection Rules & Insured Interests</h3>
                            <div className="grid grid-cols-2 gap-4">
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="principal_contractor" checked={formData.principal_contractor} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Principal Contractor</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="sub_contractor" checked={formData.sub_contractor} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Sub-contractor</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="natural_person" checked={formData.natural_person} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Natural Person</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="legal_entity" checked={formData.legal_entity} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Legal Entity (CC or (Pty) Ltd)</span>
                                </label>
                            </div>
                        </div>

                        {/* Section 2: Insured / Company Details (Mandatory) */}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">2. Insured / Company Details (Mandatory)</h3>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Name of Insured / Company Name:*</label>
                                    <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading As:</label>
                                    <input type="text" name="trading_as" value={formData.trading_as} onChange={handleChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Contact Name:*</label>
                                    <input type="text" name="contact_name" value={formData.contact_name} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Contact Numbers:*</label>
                                    <input type="text" name="contact_numbers" value={formData.contact_numbers} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Email:*</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Company Registration No:</label>
                                    <input type="text" name="company_reg_no" value={formData.company_reg_no} onChange={handleChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                </div>
                            </div>
                        </div>

                        {/* Section 3: Insurance Cover Required */}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">3. Insurance Cover Required</h3>
                            <div className="grid grid-cols-3 gap-4 mb-4">
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="owned_plant" checked={formData.owned_plant} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Owned Plant</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="hired_in_plant" checked={formData.hired_in_plant} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Hired-in Plant</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="owned_plant_hired_out" checked={formData.owned_plant_hired_out} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Owned Plant Hired-out</span>
                                </label>
                            </div>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Full Description of Plant:</label>
                                    <textarea 
                        name="equipment_description" 
                        value={formData.equipment_description} 
                        onChange={handleChange} 
                        rows="3" 
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        onKeyDown={(e) => {
                            // Preserve cursor position on backspace and delete
                            const textarea = e.target;
                            const start = textarea.selectionStart;
                            const end = textarea.selectionEnd;
                            
                            setTimeout(() => {
                                textarea.setSelectionRange(start, end);
                            }, 0);
                        }}
                    ></textarea>
                                </div>
                                <div className="grid md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">MM Number (if applicable):</label>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Year:</label>
                                        <input type="text" name="equipment_year" value={formData.equipment_year} onChange={handleChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Brief Note:</label>
                                    <textarea 
                        name="brief_note" 
                        value={formData.brief_note} 
                        onChange={handleChange} 
                        rows="3" 
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        onKeyDown={(e) => {
                            // Preserve cursor position on backspace and delete
                            const textarea = e.target;
                            const start = textarea.selectionStart;
                            const end = textarea.selectionEnd;
                            
                            setTimeout(() => {
                                textarea.setSelectionRange(start, end);
                            }, 0);
                        }}
                    ></textarea>
                                </div>
                            </div>
                        </div>

                        {/* Section 4: Preferred Contact Method */}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">4. Preferred Contact Method*</h3>
                            <div className="flex flex-wrap gap-4">
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="contact_method_call" checked={formData.contact_method_call} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Call</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="contact_method_whatsapp" checked={formData.contact_method_whatsapp} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>WhatsApp</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input type="checkbox" name="contact_method_email" checked={formData.contact_method_email} onChange={handleChange} className="h-4 w-4 text-blue-600" />
                                    <span>Email</span>
                                </label>
                            </div>
                        </div>

                        {/* Section 5: Consent & Submission */}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">5. Consent & Submission</h3>
                            <label className="flex items-center space-x-2 mb-6">
                                <input type="checkbox" name="consent" checked={formData.consent} onChange={handleChange} required className="h-4 w-4 text-blue-600" />
                                <span>I consent to being contacted by King Price or an authorized representative for insurance-related assistance.*</span>
                            </label>
                        </div>

                        <div className="flex justify-end">
                            <button type="submit" disabled={isSubmitting} className="primary-gradient text-white font-bold py-3 px-8 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50">
                                {isSubmitting ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </form>
                </div>

                {/* Policies Section */}
                <div className="mt-12 text-center">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">King Price Policy Documents</h3>
                    <p className="text-gray-600 mb-4">For detailed information regarding King Price Engineering policies, please refer to the official documents:</p>
                    <a
                        href="https://www.kingprice.co.za/personal-insurance/helpful-info/view-documents"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-blue-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center"
                    >
                        <i className="fas fa-file-alt mr-2"></i> View King Price Documents
                    </a>
                </div>

                {/* Bottom Navigation Bar for Mobile */}
                {isMobile && (
                    <BottomNavBar
                        user={user}
                        basketCount={basketCount || 0}
                        onToggleMenu={onToggleMenu || (() => setIsMobileMenuOpen(true))}
                        onShowChat={onShowChat || (() => {})}
                        onSwitchRole={onSwitchRole || (() => {})}
                        onShowLogin={onShowLogin || (() => {})}
                    />
                )}
            </div>
        </div>
    );
}
